import { css } from '@/styled-system/css';

export const listItemRecipe = css.raw({
  'paddingBlock': 'tighter',
  'paddingInline': 'none',
  '& li:first-child': {
    paddingBlockStart: 'default',
  },
  '& li:last-child': {
    paddingBlockEnd: 'none',
  },
});
